import Vue from 'vue'
import VueRouter from 'vue-router'

const OfferTest = () => import('@/views/OfferTest.vue')
const APIDocumentation = () => import('../views/API-Documentation.vue')
const Account = () => import('../views/Account.vue')
const History = () => import('../views/History.vue')
const Usage = () => import('../views/Usage.vue')
const Billing = () => import('../views/Billing.vue')
const Plans = () => import('../views/Plans.vue')
const Results = () => import('../views/full-page/Result.vue')
const AutoLogin = () => import('../views/full-page/autoLogin.vue')
const AutoTest = () => import('../views/AutoTest.vue')
const _404 = () => import('../views/404.vue')
const Verify = () => import('../views/verify.vue')
const Logs = () => import('../views/Logs.vue')
const resetPassword = () => import('../views/full-page/resetPassword.vue')
const Login = () => import('../views/full-page/Login.vue')
const ExportTestHistory = () => import("../views/ExportTestHistory.vue");
const verifyUser = () => import("../views/verifyUser.vue")

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/nav-page/index.vue'),
    children: [
      { path: '', name: 'OfferTest', component: OfferTest, meta: { title: "Link Test" } },
      { path: '/auto-tests', name: 'AutoTest', component: AutoTest, meta: { title: "Auto Test Manage" } },
      { path: '/logs/:id', name: 'Logs', component: Logs, meta: { title: "Logs" } },
      { path: 'api', name: 'APIDocumentation', component: APIDocumentation, meta: { title: "API Documentation" } },
      { path: 'profile/:id', name: 'Account', component: Account, meta: { title: "Account" } },
      { path: 'history', name: 'History', component: History, meta: { title: "History" } },
      { path: 'usage', name: 'Usage', component: Usage, meta: { title: "Usage" } },
      { path: 'details/:id', name: 'Billing', component: Billing, meta: { title: "Billing" } },
      { path: 'plans', name: 'plans', component: Plans, meta: { title: "Plans" } },
      { path: 'export-history', name: 'Export History', component: ExportTestHistory, meta: { title: "Export History" } },
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/',
    component: () => import('@/views/full-page/index.vue'),
    children: [
      { path: 'verify-user', name : 'Verify User', component: verifyUser, meta: { title: "Verify User" }},
      { path: 'link/test/:id', name: 'results', component: Results, meta: { title: "results" } },
      { path: '/auth/su/:token', name: 'AutoLogin', component: AutoLogin, meta: { title: "Auto Login" } },
      { path: 'account/verify/:id1/:id2', name: 'verify', component: Verify, meta: { title: "verify" } },
      { path: 'password/reset/:token', name: 'Password Reset', component: resetPassword, meta: { title: "Password Reset" } },
      { path: '/:id', name: 'Login', component: Login, meta: { title: "Login | Register"} },
      { path: '*', name: '404', component: _404, meta: { title: "Not Found" } },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) { return { x: 0, y: 0 } },
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if(localStorage.getItem('userToken')) {
      next();
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  } else {
    if (to.path == "/login" || to.path == "/register") {
      if (localStorage.getItem('userToken')) {
        next('/');
      }
    }
    next();
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => { document.title = to.meta.title })
})

export default router
